import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContentExtension } from './Sidebar';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContentExtension],
});
